import * as React from 'react';
import { Drawer, Box, Tab, Stack, Grid, Paper, Button } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { HeaderInformationDetails } from './header-information-details';
import { LeftInformation } from './left-information';

import { ModalFormDetail } from 'components';
import { styled } from '@mui/material/styles';
// Tab
import { TabInformationDetail } from './tabs/tab-information-detail';
import { TabCallManagement } from './tabs/tab-call-management';
import { TabEmailManagement } from './tabs/tab-email-management';
import { TabScheduleManagement } from './tabs/tab-schedule-management';
import { TabContract } from './tabs/tab-contract';
import { TabTaskJob } from './tabs/tab-task-job';
import { FeedbackCustomer } from './tabs/feedback-customer';
import { Gifts } from './tabs/gifts';
import { QuotePriceTab } from './tabs/tab-quote-price';
import { TabGeneralInfo } from './tabs/tab-general-info';

import { CLIENT_CARE_CHANGE_STATUS, CLIENT_CARE_CHANGE_NEXT_STATUS_NAME } from 'commons/constants';
import { ModalChangeStatus } from './modal-change-status';
import { ModalChangeNextStatus } from './modal-change-next-status';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const DrawerInformationDetails = ({
  isOpenDrawer,
  setIsOpenDrawer,
  clientCareHistoryItem,
  clientInformationDetail,
  getClientCareHistoryDetails,
  getDataInit,
}) => {
  const [value, setValue] = React.useState('1');
  const [showChangeStatus, setShowChangeStatus] = React.useState(false);
  const [titleStatusChange, setTitleStatusChange] = React.useState('');

  const [showChangeNextStatus, setShowChangeNextStatus] = React.useState(false);
  const [titleStatusNextChange, setTitleStatusNextChange] = React.useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function closeModalChangeStatus() {
    setShowChangeStatus(false);
    setTitleStatusChange('');
  }

  function confirmChangeStatus(statusType) {
    setShowChangeStatus(true);
    setTitleStatusChange(
      `Xác nhận bạn muốn chuyển sang ${
        CLIENT_CARE_CHANGE_STATUS[clientCareHistoryItem.clientStatusId]
      }?`,
    );
  }

  function closeModalChangeNextStatus() {
    setShowChangeNextStatus(false);
    setTitleStatusNextChange('');
  }

  const confirmChangeNextStatus = () => {
    setShowChangeNextStatus(true);
    setTitleStatusNextChange(
      `Xác nhận bạn muốn chuyển sang ${
        CLIENT_CARE_CHANGE_NEXT_STATUS_NAME[clientCareHistoryItem.clientStatusId]
      }?`,
    );
  };

  async function reloadDataAfterChangeStatus() {
    await closeModalChangeStatus();
    await closeModalChangeNextStatus();
    await setIsOpenDrawer(false);
    await getDataInit();
  }

  return (
    <ModalFormDetail
      title="Thông tin chi tiết"
      open={isOpenDrawer}
      onCloseModal={() => setIsOpenDrawer(false)}
    >
      <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>
        <Box style={{ background: '#EFFBF7', width: '300px', height: 'auto' }}>
          <LeftInformation
            clientCareHistoryItem={clientCareHistoryItem}
            clientInformationDetail={clientInformationDetail}
            getClientCareHistoryDetails={getClientCareHistoryDetails}
          />
        </Box>
        <Box style={{ background: '#FFF', width: 'calc(100% - 300px)', height: 'auto' }}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row' }}>
                <BtnChangeStatus
                  onClick={() => confirmChangeStatus()}
                  startIcon={<ArrowBackIosIcon style={{ marginRight: '0px' }} />}
                >
                  {CLIENT_CARE_CHANGE_STATUS[clientCareHistoryItem.clientStatusId] ||
                    'Chuyển trạng thái'}
                </BtnChangeStatus>
                {CLIENT_CARE_CHANGE_NEXT_STATUS_NAME[clientCareHistoryItem.clientStatusId] && (
                  <BtnNextStatus
                    onClick={() => confirmChangeNextStatus()}
                    endIcon={<ArrowForwardIosIcon />}
                  >
                    {CLIENT_CARE_CHANGE_NEXT_STATUS_NAME[clientCareHistoryItem.clientStatusId] ||
                      'Chuyển trạng thái kế tiếp'}
                  </BtnNextStatus>
                )}
              </Box>
            </Box>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  <Tab
                    sx={{ marginLeft: 4, textTransform: 'none' }}
                    label="Thông tin chung"
                    value="9"
                  />
                  <Tab
                    sx={{ marginLeft: 4, textTransform: 'none' }}
                    label="Người liên hệ"
                    value="1"
                  />
                  {/* <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Cuộc gọi" value="2" />
                  <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Mails" value="3" /> */}
                  <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Lịch hẹn" value="4" />
                  <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Công việc" value="6" />
                  <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Báo giá" value="10" />
                  <Tab sx={{ marginLeft: 4, textTransform: 'none' }} label="Hợp đồng" value="5" />
                  <Tab
                    sx={{ marginLeft: 4, textTransform: 'none' }}
                    label="Phản hồi KH"
                    value="7"
                  />
                  <Tab
                    sx={{ marginLeft: 4, textTransform: 'none' }}
                    label="DS Quà Tặng"
                    value="8"
                  />
                </TabList>
              </Box>

              <TabPanel value="1">
                <TabInformationDetail
                  clientCareHistoryItem={clientCareHistoryItem}
                  clientInformationDetail={clientInformationDetail}
                  getClientCareHistoryDetails={getClientCareHistoryDetails}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              {/* <TabPanel value="2">
                <TabCallManagement
                  clientCareHistoryItem={clientCareHistoryItem}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel> */}
              {/* <TabPanel value="3">
                <TabEmailManagement
                  clientCareHistoryItem={clientCareHistoryItem}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel> */}
              <TabPanel value="4">
                <TabScheduleManagement
                  clientCareHistoryItem={clientCareHistoryItem}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value="5">
                <TabContract
                  clientCareHistoryItem={clientCareHistoryItem}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value="6">
                <TabTaskJob
                  clientCareHistoryItem={clientCareHistoryItem}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value="7">
                <FeedbackCustomer
                  clientCareHistoryItem={clientCareHistoryItem}
                  clientInformationDetail={clientInformationDetail}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value="8">
                <Gifts
                  clientCareHistoryItem={clientCareHistoryItem}
                  clientInformationDetail={clientInformationDetail}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value="9">
                <TabGeneralInfo
                  clientCareHistoryItem={clientCareHistoryItem}
                  clientInformationDetail={clientInformationDetail}
                  value={value}
                  setValue={setValue}
                  getClientCareHistoryDetails={getClientCareHistoryDetails}
                />
              </TabPanel>
              <TabPanel value="10">
                <QuotePriceTab
                  clientCareHistoryItem={clientCareHistoryItem}
                  clientInformationDetail={clientInformationDetail}
                  value={value}
                  setValue={setValue}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </Box>
      </Box>
      <ModalFormDetail
        maxWidth="sm"
        title={titleStatusChange}
        open={showChangeStatus}
        onCloseModal={closeModalChangeStatus}
      >
        <ModalChangeStatus
          clientCareHistoryItem={clientCareHistoryItem}
          closeModalChangeStatus={closeModalChangeStatus}
          reloadDataAfterChangeStatus={reloadDataAfterChangeStatus}
        />
      </ModalFormDetail>
      <ModalFormDetail
        maxWidth="sm"
        title={titleStatusNextChange}
        open={showChangeNextStatus}
        onCloseModal={closeModalChangeNextStatus}
      >
        <ModalChangeNextStatus
          clientCareHistoryItem={clientCareHistoryItem}
          closeModalChangeStatus={closeModalChangeNextStatus}
          reloadDataAfterChangeStatus={reloadDataAfterChangeStatus}
        />
      </ModalFormDetail>
    </ModalFormDetail>
  );
};

export { DrawerInformationDetails };

const BtnChangeStatus = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#F9A907',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#F9A907',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));

const BtnNextStatus = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: 'green',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: 'green',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));
